import React from 'react'
import { Input, InputProps } from 'semantic-ui-react'

interface IOwnProps extends InputProps {
  validate?: RegExp

  onChange(value: any): void
}

export type FilterInputProps = IOwnProps

export default class FilterInput extends React.Component<FilterInputProps> {
  state = {
    value: ''
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { validate, onChange } = this.props

    const value = e && e.target && e.target.value

    if (!validate || validate.test(value) || value === '') {
      this.setState({
        value
      })

      onChange(value)
    }
  }

  render() {
    const { validate, value: propValue, ...rest } = this.props
    const { value } = this.state

    return <Input {...rest} value={propValue !== undefined ? propValue : value} onChange={this.onChange} />
  }
}
